"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const meUnreadMessagesCount = (accessToken) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    if (accessToken) {
        headers.append('Authorization', `Bearer ${accessToken}`);
    }
    const response = yield (yield fetch('https://api.sportnet.online/v1/me/messages-unread-count', {
        headers,
    })).json();
    return (response === null || response === void 0 ? void 0 : response.count) || -1;
});
exports.default = meUnreadMessagesCount;
